// extracted by mini-css-extract-plugin
export default {"Box":"filter-counter-label-module__Box--b0cKU"};